function inserted(el, binding, vnode) {
    if (typeof window === 'undefined' || !('IntersectionObserver' in window))
        return;
    const modifiers = binding.modifiers || {};
    const value = binding.value;
    const { handler, options } = typeof value === 'object' ? value : {
        handler: value,
        options: {}
    };
    const observer = new IntersectionObserver((entries = [], observer) => {
        var _el$_observe;
        const _observe = (_el$_observe = el._observe) == null ? void 0 : _el$_observe[vnode.context._uid];
        if (!_observe)
            return;
        const isIntersecting = entries.some(entry => entry.isIntersecting);
        if (handler && (!modifiers.quiet || _observe.init) && (!modifiers.once || isIntersecting || _observe.init)) {
            handler(entries, observer, isIntersecting);
        }
        if (isIntersecting && modifiers.once)
            unbind(el, binding, vnode);
        else
            _observe.init = true;
    }, options);
    el._observe = Object(el._observe);
    el._observe[vnode.context._uid] = {
        init: false,
        observer
    };
    observer.observe(el);
}
function unbind(el, binding, vnode) {
    var _el$_observe2;
    const observe = (_el$_observe2 = el._observe) == null ? void 0 : _el$_observe2[vnode.context._uid];
    if (!observe)
        return;
    observe.observer.unobserve(el);
    delete el._observe[vnode.context._uid];
}
export const Intersect = {
    inserted,
    unbind
};
export default Intersect;
